export const FETCH_REPORT_CONFIGURATION_REQUEST = 'FETCH_REPORT_CONFIGURATION_REQUEST';
export const FETCH_REPORT_CONFIGURATION_SUCCESS = 'FETCH_REPORT_CONFIGURATION_SUCCESS'; 
export const FETCH_REPORT_CONFIGURATION_FAILURE = 'FETCH_REPORT_CONFIGURATION_FAILURE';

export const SAVE_REPORT_CONFIGURATION_REQUEST = 'SAVE_REPORT_CONFIGURATION_REQUEST';
export const SAVE_REPORT_CONFIGURATION_SUCCESS = 'SAVE_REPORT_CONFIGURATION_SUCCESS';
export const SAVE_REPORT_CONFIGURATION_FAILURE = 'SAVE_REPORT_CONFIGURATION_FAILURE';

export const FETCH_REPORT_CONFIGURATION_BY_ID_REQUEST = 'FETCH_REPORT_CONFIGURATION_BY_ID_REQUEST';
export const FETCH_REPORT_CONFIGURATION_BY_ID_SUCCESS = 'FETCH_REPORT_CONFIGURATION_BY_ID_SUCCESS';
export const FETCH_REPORT_CONFIGURATION_BY_ID_FAILURE = 'FETCH_REPORT_CONFIGURATION_BY_ID_FAILURE';

export const ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_REQUEST = 'ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_REQUEST';
export const ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_SUCCESS = 'ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_SUCCESS';
export const ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_FAILURE = 'ACTIVATE_DEACTIVATE_REPORT_CONFIGURATION_FAILURE';

export const FETCH_POWERBI_REFRESH_STATUS_REQUEST = 'FETCH_POWERBI_REFRESH_STATUS_REQUEST';
export const FETCH_POWERBI_REFRESH_STATUS_SUCCESS = 'FETCH_POWERBI_REFRESH_STATUS_SUCCESS';
export const FETCH_POWERBI_REFRESH_STATUS_FAILURE = 'FETCH_POWERBI_REFRESH_STATUS_FAILURE';

export const FETCH_CAPACITY_DROPDOWN_REQUEST = 'FETCH_CAPACITY_DROPDOWN_REQUEST';
export const FETCH_CAPACITY_DROPDOWN_SUCCESS = 'FETCH_CAPACITY_DROPDOWN_SUCCESS';
export const FETCH_CAPACITY_DROPDOWN_FAILURE = 'FETCH_CAPACITY_DROPDOWN_FAILURE';

// Common Action Types
export const UPDATE_REPORT_REDUCER = 'UPDATE_REPORT_REDUCER';